import React from 'react';
import cx from 'classnames';
import useDraggable from '~hooks/useDragScroll';

import './style.scss';

const Carousel = ({ children, className, draggable: enableDrag = false }) => {
  const dragRef = useDraggable();

  if (!children || !children.length) return null;

  return (
    <div
      className={cx('c-carousel', {
        [className]: !!className,
        'c-carousel--draggable': enableDrag,
      })}
      ref={enableDrag ? dragRef : null}
    >
      {children}
    </div>
  );
};

export default Carousel;
